import { serviceCreate, merge } from "./modules/request";
//这种方式可以采用单个项目的接口，也可以使用多个项目的接口，看自己的项目情况而定
let http = serviceCreate({
  baseURL: "https://core.kaixinchuichui.cn/admin/index.php",
  timeout: 6000000, //请求超时
  emulateJSON: true //默认表单提交
});


//飞书登录
export function fsAuth(params, config) {
  return http.post(
    "/fsapi/login/fsAuth",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function xfxAuth(params, config) {
  return http.post(
    "/fsapi/login/xfx_auth",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function login(params, config) {
  return http.post(
    "/api/login/mobile",
    params,
    merge(config, { emulateJSON: false })
  );
}
//验证码获取
export function captcha(params, config) {
  return http.post(
    "/api/login/mobileCode",
    params,
    merge(config, { emulateJSON: false })
  );
}

/*
params:{
   page
   page_size
}
审核列表接口 */
export function getCartoon_lists(params, config) {
  return http.get("/api/cartoon/lists", merge(config, { params }));
}
/*主题详情 */
export function getThemeInfo(params, config) {
  return http.get("/api/cartoon/themeInfo", merge(config, { params }));
}

//主题添加接口
export function cartoon_add(params, config) {
  return http.post(
    "/api/cartoon/add",
    params,
    merge(config, { emulateJSON: false })
  );
}

/*事件审核接口 */
export function event_examine_list(params, config) {
  return http.get("/api/cartoon/event_examine_list", merge(config, { params }));
}
//事件修改接口
export function event_examine_revise(params, config) {
  return http.post(
    "/api/cartoon/event_examine_revise ",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*事件通过接口 */
export function event_examine_pass(params, config) {
  return http.get("/api/cartoon/event_examine_pass", merge(config, { params }));
}

/*事件备选接口 */
export function event_examine_pref(params, config) {
  return http.get("/api/cartoon/event_examine_pref", merge(config, { params }));
}
/*剧本审核接口 */
export function script_examine_list(params, config) {
  return http.get(
    "/api/cartoon/script_examine_list",
    merge(config, { params })
  );
}
//剧本修改接口
export function script_examine_revise(params, config) {
  return http.post(
    "/api/cartoon/script_examine_revise",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*剧本通过接口 */
export function script_examine_pass(params, config) {
  return http.get(
    "/api/cartoon/script_examine_pass",
    merge(config, { params })
  );
}
/*分镜审核接口 */
export function storyboard_examine_list(params, config) {
  return http.get(
    "/api/cartoon/storyboard_examine_list",
    merge(config, { params })
  );
}
//分镜修改接口
export function storyboard_examine_revise(params, config) {
  return http.post(
    "/api/cartoon/storyboard_examine_revise",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*分镜通过接口 */
export function storyboard_examine_pass(params, config) {
  return http.get(
    "/api/cartoon/storyboard_examine_pass",
    merge(config, { params })
  );
}
/*动画审核接口 */
export function animation_examine_list(params, config) {
  return http.get(
    "/api/cartoon/animation_examine_list",
    merge(config, { params })
  );
}
//动画修改接口
export function animation_examine_revise(params, config) {
  return http.post(
    "/api/cartoon/animation_examine_revise",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*动画通过接口 */
export function animation_examine_pass(params, config) {
  return http.get(
    "/api/cartoon/animation_examine_pass",
    merge(config, { params })
  );
}

//事件前端修改添加接口
export function event_edit(params, config) {
  return http.post(
    "/api/cartoon/event_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*事件前端显示接口口 */
export function cartoon_event(params, config) {
  return http.get("/api/cartoon/event", merge(config, { params }));
}
//剧本前端修改添加接口
export function script_verify(params, config) {
  return http.post(
    "/api/test/verify",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function idealist(params, config) {
  return http.post(
    "/api/test/idealist",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function script_edit(params, config) {
  return http.post(
    "/api/cartoon/script_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*剧本前端显示接口*/
export function cartoon_script(params, config) {
  return http.get("/api/cartoon/script", merge(config, { params }));
}

//分镜前端修改添加接口
export function storyboard_edit(params, config) {
  return http.post(
    "/api/cartoon/storyboard_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*分镜前端显示接口*/
export function cartoon_storyboard(params, config) {
  return http.get("/api/cartoon/storyboard", merge(config, { params }));
}
//动画前端显示接口
export function animation_edit(params, config) {
  return http.post(
    "/api/cartoon/animation_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*动画前端显示接口*/
export function cartoon_animation(params, config) {
  return http.get("/api/cartoon/animation", merge(config, { params }));
}

/* *********************************** */
//模板
export function class_list(params, config) {
  return http.get("/create/api/create/class_list", merge(config, { params }));
}
//模板详情
export function class_details(params, config) {
  return http.get(
    "/create/api/create/class_details",
    merge(config, { params })
  );
}
//点子分类 游戏 其他
export function idea_class(params, config) {
  return http.get("/create/api/create/idea_class", merge(config, { params }));
}
//类型对应的点子 class_id
export function idea_list(params, config) {
  return http.post(
    "/create/api/create/idea_list",
    params,
    merge(config, { emulateJSON: false })
  );
}
//点子详情 //点子id
export function idea_info(params, config) {
  return http.post(
    "/create/api/create/idea_info",
    params,
    merge(config, { emulateJSON: false })
  );
}
//顶级词汇列表
//group   //分组  场景：scene   角色：role
export function getAlbumList(params, config) {
  return http.get("/api/album/getAlbumList", merge(config, { params }));
}
//对应下级词汇列表（params：album_id   //上级词汇id）
export function getLower(params, config) {
  return http.get("/api/album/getLower", merge(config, { params }));
}

//词汇图片接口
export function album_lists(params, config) {
  return http.get("/api/album/lists", merge(config, { params }));
}
//拒绝事件
export function event_examine_refuse(params, config) {
  return http.get(
    "/api/cartoon/event_examine_refuse",
    merge(config, { params })
  );
}
//拒绝剧本
export function script_examine_refuse(params, config) {
  return http.get(
    "/api/cartoon/script_examine_refuse",
    merge(config, { params })
  );
}
//拒绝分镜
export function storyboard_examine_refuse(params, config) {
  return http.get(
    "/api/cartoon/storyboard_examine_refuse",
    merge(config, { params })
  );
}
//拒绝动画
export function animation_examine_refuse(params, config) {
  return http.get(
    "/api/cartoon/animation_examine_refuse",
    merge(config, { params })
  );
}
/*大纲审核列表 */
export function outline_examine_list(params, config) {
  return http.get(
    "/api/cartoon/outline_examine_list",
    merge(config, { params })
  );
}
/*大纲审核拒绝接口 */
export function outline_examine_refuse(params, config) {
  return http.get(
    "/api/cartoon/outline_examine_refuse",
    merge(config, { params })
  );
}
//大纲修改接口
export function outline_examine_revise(params, config) {
  return http.post(
    "/api/cartoon/outline_examine_revise ",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*大纲通过接口 */
export function outline_examine_pass(params, config) {
  return http.get(
    "/api/cartoon/outline_examine_pass",
    merge(config, { params })
  );
}
//大纲前端修改添加接口
export function outline_edit(params, config) {
  return http.post(
    "/api/cartoon/outline_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*大纲前端显示接口口 */
export function cartoon_outline(params, config) {
  return http.get("/api/cartoon/outline", merge(config, { params }));
}

/*审查端显示接口 */
export function examination_list(params, config) {
  return http.get("/api/cartoon/examination_list", merge(config, { params }));
}
/*审查端通过接口 */
export function examination_pass(params, config) {
  return http.get("/api/cartoon/examination_pass", merge(config, { params }));
}
/*审查端添加修改意见接口 */
export function add_examination_comment(params, config) {
  return http.post(
    "/api/cartoon/add_examination_comment",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*审查端修改意见显示接口 */
export function examination_comment_list(params, config) {
  return http.get("/api/cartoon/examination_comment_list", merge(config, { params }));
}

/*事件梗列表 */
export function eventstem_list(params, config) {
  return http.get(
    "/api/cartoon/eventstem_list",
    merge(config, { params })
  );
}

/*我的事件梗列表 */
export function eventstem(params, config) {
  return http.get(
    "/api/cartoon/eventstem",
    merge(config, { params })
  );
}
/*事件梗添加修改接口 */
export function add_stem(params, config) {
  return http.post(
    "/api/cartoon/add_stem",
    params,
    merge(config, { emulateJSON: false })
  );
}
//权限控制
export function cartoon_home(params, config) {
  return http.get("/api/cartoon/home", merge(config, { params }));
}
// **************************************************
// 锤锤画图
/*
top_id:为上级图片类型id   顶级栏目 传参 0
 */
export function classImg(params, config) {
  return http.get("/api/ImgCreate/classImg", merge(config, { params }));
}

//图片分类
export function folderlist(params, config) {
  return http.get("/api/ImgCreate/folderlist?online=1", merge(config, { params }));
}

//图片制作人
export function imgmember(params, config) {
  return http.get("/api/ImgCreate/imgmember", merge(config, { params }));
}


//图片项目
export function imgproject(params, config) {
  return http.get("/api/ImgCreate/imgproject", merge(config, { params }));
}
//top_id   三级分类id
// page
// page_size
export function class_page(params, config) {
  return http.get("/api/ImgCreate/classpage", merge(config, { params }));
}
//模板添加
export function template_add(params, config) {
  return http.post(
    "/api/ImgCreate/templateadd",
    params,
    merge(config, { emulateJSON: false })
  );
}
// 模板列表
export function template_page(params, config) {
  return http.get("/api/ImgCreate/templatepage", merge(config, { params }));
}
//图片添加
export function addImg(params, config) {
  return http.post(
    "/api/ImgCreate/addimg",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function evaluateimg(params, config) {
  return http.post(
    "/api/upload/evaluateimg",
    params,
    config
  );
}

export function headimg(params, config) {
  return http.post(
    "/api/upload/headimg",
    params,
    config
  );
}
//图片服务列表
export function imgServer(params, config) {
  return http.get("/api/ImgCreate/imgserver?online=1", merge(config, { params }));
}
// 图片列表
export function imgPage(params, config) {
  return http.get("/api/ImgCreate/imgpage?online=1", merge(config, { params }));
}
//id：图片id
// 图片详情
export function img_info(params, config) {
  return http.get("/api/ImgCreate/imginfo?online=1", merge(config, { params }));
}
//id：图片id
// 删除图片
export function del_img(params, config) {
  return http.get("/api/ImgCreate/delimg", merge(config, { params }));
}
//id：图片id
//图片设置选中或取消选中
export function img_selected(params, config) {
  return http.get("/api/ImgCreate/imgselected", merge(config, { params }));
}
//id：图片id
//图片设置主图
export function ImgCreate_mainImg(params, config) {
  return http.get("/api/ImgCreate/mainimg", merge(config, { params }));
}
//img_id：图片id
// comment：评论内容
//图片评论添加
export function add_comment(params, config) {
  return http.get("/api/ImgCreate/addcomment", merge(config, { params }));
}
//评论列表
//img_id：图片id
export function img_comment(params, config) {
  return http.get("/api/ImgCreate/imgcomment", merge(config, { params }));
}

//类型添加
export function addClass(params, config) {
  return http.post(
    "/api/ImgCreate/addclass",
    params,
    merge(config, { emulateJSON: false })
  );
}
//类型修改
export function editclass(params, config) {
  return http.post(
    "/api/ImgCreate/editclass",
    params,
    merge(config, { emulateJSON: false })
  );
}
//类型删除
export function delclass(params, config) {
  return http.post(
    "/api/ImgCreate/delclass",
    params,
    merge(config, { emulateJSON: false })
  );
}
//文件详情
//id
export function file_class_info(params, config) {
  return http.get("/api/ImgCreate/classinfo", merge(config, { params }));
}

//事件作者名称
export function event_member_list(params, config) {
  return http.get("/api/cartoon/event_member_list", merge(config, { params }));
}

//简历部门
export function classResume(params, config) {
  return http.get("/api/resume/classResume", merge(config, { params }));
}

//简历岗位
export function postResume(params, config) {
  return http.get("/api/resume/postResume", merge(config, { params }));
}

//简历列表
export function resumePage(params, config) {
  return http.get("/api/resume/resumePage", merge(config, { params }));
}

//列表
export function memberlist(params, config) {
  return http.get("/api/resume/memberlist", merge(config, { params }));
}
//简历添加
export function addResume(params, config) {
  return http.post(
    "/api/resume/addResume",
    params,
    merge(config, { emulateJSON: false })
  );
}

//简历修改
export function updateResume(params, config) {
  return http.post(
    "/api/resume/updateResume",
    params,
    merge(config, { emulateJSON: false })
  );
}


//添加部门
export function addResumeclass(params, config) {
  return http.post(
    "/api/resume/addclass",
    params,
    merge(config, { emulateJSON: false })
  );
}

//添加岗位
export function addResumepost(params, config) {
  return http.post(
    "/api/resume/addpost",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function essential_data(params, config) {
  return http.get("/api/cartoon/essential_data", merge(config, { params }));
}

//添加总结
export function add_give_comment(params, config) {
  return http.post(
    "/api/cartoon/add_give_comment",
    params,
    merge(config, { emulateJSON: false })
  );
}
//总结列表
export function give_comment_list(params, config) {
  return http.get("/api/cartoon/give_comment_list", merge(config, { params }));
}

//动画总结列
export function give_list(params, config) {
  return http.get("/api/cartoon/give_list", merge(config, { params }));
}

export function cartoon_class(params, config) {
  return http.get("/api/cart/cartoonClass", merge(config, { params }));
}

export function cartoon_position(params, config) {
  return http.get("/api/cart/cartoonPosition", merge(config, { params }));
}

export function member_list(params, config) {
  return http.get("/api/cartoon/member_list", merge(config, { params }));
}

export function del_examination_comment(params, config) {
  return http.get("/api/cartoon/del_examination_comment", merge(config, { params }));
}

/*ai事件审核接口 */
export function aievent_examine_list(params, config) {
  return http.get("/api/cartoon/aievent_examine_list", merge(config, { params }));
}
/*ai事件通过接口 */
export function aievent_examine_pass(params, config) {
  return http.get("/api/cartoon/aievent_examine_pass", merge(config, { params }));
}

/*ai事件备选接口 */
export function aievent_examine_pref(params, config) {
  return http.get("/api/cartoon/aievent_examine_pref", merge(config, { params }));
}

export function aievent_examine_refuse(params, config) {
  return http.get(
    "/api/cartoon/aievent_examine_refuse",
    merge(config, { params })
  );
}

export function aievent_edit(params, config) {
  return http.post(
    "/api/cartoon/aievent_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function add_aievent(params, config) {
  return http.post(
    "/api/cartoon/add_aievent",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*事件审核接口 */
export function tred_event_examine_list(params, config) {
  return http.get("/api/tredcartoon/event_examine_list", merge(config, { params }));
}

/*事件通过接口 */
export function tred_event_examine_pass(params, config) {
  return http.get("/api/tredcartoon/event_examine_pass", merge(config, { params }));
}

/*事件备选接口 */
export function tred_event_examine_pref(params, config) {
  return http.get("/api/tredcartoon/event_examine_pref", merge(config, { params }));
}
/*剧本审核接口 */
export function tred_script_examine_list(params, config) {
  return http.get(
    "/api/tredcartoon/script_examine_list",
    merge(config, { params })
  );
}
/*剧本通过接口 */
export function tred_script_examine_pass(params, config) {
  return http.get(
    "/api/tredcartoon/script_examine_pass",
    merge(config, { params })
  );
}
//拒绝事件
export function tred_event_examine_refuse(params, config) {
  return http.get(
    "/api/tredcartoon/event_examine_refuse",
    merge(config, { params })
  );
}
//拒绝剧本
export function tred_script_examine_refuse(params, config) {
  return http.get(
    "/api/tredcartoon/script_examine_refuse",
    merge(config, { params })
  );
}

//事件前端修改添加接口
export function tred_event_edit(params, config) {
  return http.post(
    "/api/tredcartoon/event_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
//剧本前端修改添加接口
export function tred_script_edit(params, config) {
  return http.post(
    "/api/tredcartoon/script_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}



//分镜前端修改添加接口
export function tred_storyboard_edit(params, config) {
  return http.post(
    "/api/tredcartoon/storyboard_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*分镜前端显示接口*/
export function tred_cartoon_storyboard(params, config) {
  return http.get("/api/tredcartoon/storyboard", merge(config, { params }));
}
//动画前端显示接口
export function tred_animation_edit(params, config) {
  return http.post(
    "/api/tredcartoon/animation_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*动画前端显示接口*/
export function tred_cartoon_animation(params, config) {
  return http.get("/api/tredcartoon/animation", merge(config, { params }));
}

/*事件梗列表 */
export function tred_eventstem_list(params, config) {
  return http.get(
    "/api/tredcartoon/eventstem_list",
    merge(config, { params })
  );
}

/*事件梗添加修改接口 */
export function tred_add_stem(params, config) {
  return http.post(
    "/api/tredcartoon/add_stem",
    params,
    merge(config, { emulateJSON: false })
  );
}

/*大纲审核列表 */
export function tred_outline_examine_list(params, config) {
  return http.get(
    "/api/tredcartoon/outline_examine_list",
    merge(config, { params })
  );
}
/*大纲审核拒绝接口 */
export function tred_outline_examine_refuse(params, config) {
  return http.get(
    "/api/tredcartoon/outline_examine_refuse",
    merge(config, { params })
  );
}
/*大纲通过接口 */
export function tred_outline_examine_pass(params, config) {
  return http.get(
    "/api/tredcartoon/outline_examine_pass",
    merge(config, { params })
  );
}
//大纲前端修改添加接口
export function tred_outline_edit(params, config) {
  return http.post(
    "/api/tredcartoon/outline_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function tred_member_list(params, config) {
  return http.get("/api/tredcartoon/member_list", merge(config, { params }));
}
/*ai事件审核接口 */
export function tred_aievent_examine_list(params, config) {
  return http.get("/api/tredcartoon/aievent_examine_list", merge(config, { params }));
}
/*ai事件通过接口 */
export function tred_aievent_examine_pass(params, config) {
  return http.get("/api/tredcartoon/aievent_examine_pass", merge(config, { params }));
}

/*ai事件备选接口 */
export function tred_aievent_examine_pref(params, config) {
  return http.get("/api/tredcartoon/aievent_examine_pref", merge(config, { params }));
}

export function tred_aievent_examine_refuse(params, config) {
  return http.get(
    "/api/tredcartoon/aievent_examine_refuse",
    merge(config, { params })
  );
}

export function tred_aievent_edit(params, config) {
  return http.post(
    "/api/tredcartoon/aievent_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function tred_add_aievent(params, config) {
  return http.post(
    "/api/tredcartoon/add_aievent",
    params,
    merge(config, { emulateJSON: false })
  );
}


export function event_sync(params, config) {
  return http.get("/api/tredcartoon/event_sync", merge(config, { params }));
}

export function flow_data(params, config) {
  return http.get("/api/cartoon/flow_data", merge(config, { params }));
}


export function three_add_comment(params, config) {
  return http.post(
    "/api/tredcartoon/add_comment",
    params,
    merge(config, { params })
  );
}

export function three_comment_list(params, config) {
  return http.get("/api/tredcartoon/comment_list", merge(config, { params }));
}

export function scene_add(params, config) {
  return http.post(
    "/api/tredcartoon/scene_add",
    params,
    merge(config, { params })
  );
}

export function scene_list(params, config) {
  return http.get("/api/tredcartoon/scene_list", merge(config, { params }));
}

export function tred_animation_examine_status(params, config) {
  return http.get(
    "/api/tredcartoon/animation_examine_status",
    merge(config, { params })
  );
}




/*事件审核接口 */
export function rd_event_examine_list(params, config) {
  return http.get("/api/rdcartoon/event_examine_list", merge(config, { params }));
}

/*事件通过接口 */
export function rd_event_examine_pass(params, config) {
  return http.get("/api/rdcartoon/event_examine_pass", merge(config, { params }));
}

/*事件备选接口 */
export function rd_event_examine_pref(params, config) {
  return http.get("/api/rdcartoon/event_examine_pref", merge(config, { params }));
}
/*剧本审核接口 */
export function rd_script_examine_list(params, config) {
  return http.get(
    "/api/rdcartoon/script_examine_list",
    merge(config, { params })
  );
}
/*剧本通过接口 */
export function rd_script_examine_pass(params, config) {
  return http.get(
    "/api/rdcartoon/script_examine_pass",
    merge(config, { params })
  );
}
//拒绝事件
export function rd_event_examine_refuse(params, config) {
  return http.get(
    "/api/rdcartoon/event_examine_refuse",
    merge(config, { params })
  );
}
//拒绝剧本
export function rd_script_examine_refuse(params, config) {
  return http.get(
    "/api/rdcartoon/script_examine_refuse",
    merge(config, { params })
  );
}

//事件前端修改添加接口
export function rd_event_edit(params, config) {
  return http.post(
    "/api/rdcartoon/event_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
//剧本前端修改添加接口
export function rd_script_edit(params, config) {
  return http.post(
    "/api/rdcartoon/script_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}

//分镜前端修改添加接口
export function rd_storyboard_edit(params, config) {
  return http.post(
    "/api/rdcartoon/storyboard_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*分镜前端显示接口*/
export function rd_cartoon_storyboard(params, config) {
  return http.get("/api/rdcartoon/storyboard", merge(config, { params }));
}
//动画前端显示接口
export function rd_animation_edit(params, config) {
  return http.post(
    "/api/rdcartoon/animation_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
/*动画前端显示接口*/
export function rd_cartoon_animation(params, config) {
  return http.get("/api/rdcartoon/animation", merge(config, { params }));
}

/*事件梗列表 */
export function rd_eventstem_list(params, config) {
  return http.get(
    "/api/rdcartoon/eventstem_list",
    merge(config, { params })
  );
}

/*事件梗添加修改接口 */
export function rd_add_stem(params, config) {
  return http.post(
    "/api/rdcartoon/add_stem",
    params,
    merge(config, { emulateJSON: false })
  );
}

/*大纲审核列表 */
export function rd_outline_examine_list(params, config) {
  return http.get(
    "/api/rdcartoon/outline_examine_list",
    merge(config, { params })
  );
}
/*大纲审核拒绝接口 */
export function rd_outline_examine_refuse(params, config) {
  return http.get(
    "/api/rdcartoon/outline_examine_refuse",
    merge(config, { params })
  );
}
/*大纲通过接口 */
export function rd_outline_examine_pass(params, config) {
  return http.get(
    "/api/rdcartoon/outline_examine_pass",
    merge(config, { params })
  );
}
//大纲前端修改添加接口
export function rd_outline_edit(params, config) {
  return http.post(
    "/api/rdcartoon/outline_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function rd_member_list(params, config) {
  return http.get("/api/rdcartoon/member_list", merge(config, { params }));
}
/*ai事件审核接口 */
export function rd_aievent_examine_list(params, config) {
  return http.get("/api/rdcartoon/aievent_examine_list", merge(config, { params }));
}
/*ai事件通过接口 */
export function rd_aievent_examine_pass(params, config) {
  return http.get("/api/rdcartoon/aievent_examine_pass", merge(config, { params }));
}

/*ai事件备选接口 */
export function rd_aievent_examine_pref(params, config) {
  return http.get("/api/rdcartoon/aievent_examine_pref", merge(config, { params }));
}

export function rd_aievent_examine_refuse(params, config) {
  return http.get(
    "/api/rdcartoon/aievent_examine_refuse",
    merge(config, { params })
  );
}

export function rd_aievent_edit(params, config) {
  return http.post(
    "/api/rdcartoon/aievent_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function rd_add_aievent(params, config) {
  return http.post(
    "/api/rdcartoon/add_aievent",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function theme_lists(params, config) {
  return http.get("/api/theme/lists", merge(config, { params }));
}
export function add_theme(params, config) {
  return http.post(
    "/api/theme/addtheme",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function item_list(params, config) {
  return http.get("/api/theme/itemlist", merge(config, { params }));
}
export function add_theme_item(params, config) {
  return http.post(
    "/api/theme/addItem",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function item_del(params, config) {
  return http.get("/api/theme/delItem", merge(config, { params }));
}
export function secenlist(params, config) {
  return http.get("/api/rdcartoon/secenlist", merge(config, { params }));
}
export function addsecen(params, config) {
  return http.post(
    "/api/rdcartoon/addsecen",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function examinationdata(params, config) {
  return http.get("/api/theme/examinationdata", merge(config, { params }));
}


export function project(params, config) {
  return http.get("/api/theme/project", merge(config, { params }));
}

export function project_member(params, config) {
  return http.get("/api/theme/project_member", merge(config, { params }));
}

export function project_add(params, config) {
  return http.get("/api/theme/project_add", merge(config, { params }));
}

export function project_info(params, config) {
  return http.get("/api/theme/project_info", merge(config, { params }));
}

export function add_item(params, config) {
  return http.post(
    "/api/theme/add_item",
    params,
    merge(config, { emulateJSON: false })
  );
}


export function del_item(params, config) {
  return http.get("/api/theme/del_item", merge(config, { params }));
}
export function info_item(params, config) {
  return http.get("/api/theme/info_item", merge(config, { params }));
}
export function edit_item(params, config) {
  return http.post(
    "/api/theme/edit_item",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function info_add(params, config) {
  return http.get("/api/theme/info_add", merge(config, { params }));
}

export function is_open(params, config) {
  return http.get("/api/theme/is_open", merge(config, { params }));
}

export function add_advise(params, config) {
  return http.post(
    "/api/system/add_advise",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function drag_edit_item(params, config) {
  return http.post(
    "/api/theme/drag_edit_item",
    params,
    merge(config, { emulateJSON: false })
  );
}


export function universe_info(params, config) {
  return http.get("/api/theme/universe", merge(config, { params }));
}
export function universe_img_list(params, config) {
  return http.get("/api/theme/universe_img", merge(config, { params }));
}
export function universe_add_item(params, config) {
  return http.post(
    "/api/theme/universe_add",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function universe_edit(params, config) {
  return http.post(
    "/api/theme/universe_edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function universe_del_item(params, config) {
  return http.get("/api/theme/universe_del", merge(config, { params }));
}
export function universe_edit_item(params, config) {
  return http.get("/api/theme/universe_edit_item", merge(config, { params }));
}
export function universe_is_open(params, config) {
  return http.get("/api/theme/universe_is_open", merge(config, { params }));
}
export function universe_del_img(params, config) {
  return http.get("/api/theme/universe_del_img", merge(config, { params }));
}
export function is_main_img(params, config) {
  return http.get("/api/theme/is_main_img", merge(config, { params }));
}

export function add_meeting(params, config) {
  return http.post(
    "/api/meeting/add_meeting",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function info_meeting(params, config) {
  return http.get("/api/meeting/lists", merge(config, { params }));
}

export function examination_give(params, config) {
  return http.post(
    "/api/cartoon/examination_give",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function examination_give_list(params, config) {
  return http.get("/api/cartoon/examination_give_list", merge(config, { params }));
}


export function test_title_list(params, config) {
  return http.get("/api/test/lists", merge(config, { params }));
}

export function test_title_add(params, config) {
  return http.post(
    "/api/test/add",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function test_title_create(params, config) {
  return http.post(
    "/api/test/create",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function test_title_create_ts(params, config) {
  return http.post(
    "/api/test/ts_create",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function achievements(params, config) {
  return http.post(
    "/api/test/achievements",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function imglist(params, config) {
  return http.get("/api/test/imglist", merge(config, { params }));
}
export function getdraw(params, config) {
  return http.get("/api/test/getdraw", merge(config, { params }));
}
export function add_draw(params, config) {
  return http.post(
    "/api/test/add_draw",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function img_update_name(params, config) {
  return http.post(
    "/api/test/img_update_name",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function roleadd(params, config) {
  return http.post(
    "/api/test/roleadd",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function test_classlists(params, config) {
  return http.get("/api/test/classlists", merge(config, { params }));
}

export function test_templatelist(params, config) {
  return http.get("/api/test/templatelist", merge(config, { params }));
}

export function test_part_add(params, config) {
  return http.post(
    "/api/test/part_add",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function test_del_part(params, config) {
  return http.post(
    "/api/test/del_part",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function chat_page(params, config) {
  
  return http.get("/api/chatgpt/chat_page", merge(config, { params }));
}

export function chat_say(params, config) {
  return http.post(
    "/api/chatgpt/say",
    params,
    merge(config, { emulateJSON: false })
  );
}


export function chat_say1(params, config) {
  return http.post(
    "/api/chatgpt/say1",
    params,
    merge(config, { emulateJSON: false })
  );
}


export function chat_dialogs(params, config) {
  
  return http.get("/api/chatgpt/dialogs", merge(config, { params }));
}
export function chat_del(params, config) {
  
  return http.get("/api/chatgpt/del", merge(config, { params }));
}
export function getchatid(params, config) {
  
  return http.get("/api/chatgpt/getchatid", merge(config, { params }));
}

export function member_info(params, config) {
  
  return http.get("/api/member/info", merge(config, { params }));
}

export function import_class(params, config) {
  
  return http.get("/api/import/importClass", merge(config, { params }));
}
export function vocabularys(params, config) {
  
  return http.get("/api/import/vocabularys", merge(config, { params }));
}
export function twolist(params, config) {
  
  return http.get("/api/import/twolist", merge(config, { params }));
}

export function import_addclass(params, config) {
  return http.post(
    "/api/import/addclass",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function addimport(params, config) {
  return http.post(
    "/api/import/addimport",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function translate(params, config) {
  return http.post(
    "/api/import/translate",
    params,
    merge(config, { emulateJSON: false })
  );
}


export function test_end(params, config) {
  return http.post(
    "/api/question/test_end",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function start_test(params, config) {
  
  return http.get("/api/question/start_test", merge(config, { params }));
}

export function test_rang(params, config) {
  
  return http.get("/api/question/test_rang", merge(config, { params }));
}

export function test_page(params, config) {
  
  return http.get("/api/question/page", merge(config, { params }));
}

export function test_del(params, config) {
  
  return http.get("/api/question/deltest", merge(config, { params }));
}
export function test_add(params, config) {
  return http.post(
    "/api/question/add",
    params,
    merge(config, { emulateJSON: false })
  );
}




export function postUniverse(params, config) {
  return http.get("/api/universe/postUniverse", merge(config, { params }));
}

export function universePage(params, config) {
  return http.get("/api/universe/universePage", merge(config, { params }));
}

export function addUniverse(params, config) {
  return http.post(
    "/api/universe/addUniverse",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function classUniverse(params, config) {
  return http.get("/api/universe/classUniverse", merge(config, { params }));
}
export function addUniverseclass(params, config) {
  return http.post(
    "/api/universe/addclass",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function addUniversepost(params, config) {
  return http.post(
    "/api/universe/addpost",
    params,
    merge(config, { emulateJSON: false })
  );
}

/*视频课程学习 */
export function categories(params, config) {
  return http.get("/api/course/categories", merge(config, { params }));
}

export function course_page(params, config) {
  return http.get("/api/course/page", merge(config, { params }));
}

export function course_detail(params, config) {
  return http.get("/api/course/detail", merge(config, { params }));
}

export function recordVideo(params, config) {
  return http.get("/api/course/recordVideo", merge(config, { params }));
}

export function playInfo(params, config) {
  return http.get("/api/course/playInfo", merge(config, { params }));
}

export function course_ranking(params, config) {
  return http.get("/api/course/ranking", merge(config, { params }));
}

export function course_mypage(params, config) {
  return http.get("/api/course/mypage", merge(config, { params }));
}

export function video_speed(params, config) {
  return http.get("/api/course/videospeed", merge(config, { params }));
}

export function music_page(params, config) {
  return http.get("/api/music/page", merge(config, { params }));
}

export function music_edit(params, config) {
  return http.post(
    "/api/music/edit",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function audio_page(params, config) {
  return http.get("/api/audio/page", merge(config, { params }));
}

export function audio_edit(params, config) {
  return http.post(
    "/api/audio/edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function audio_del(params, config) {
  return http.post(
    "/api/audio/del",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function classIp(params, config) {
  return http.get("/api/ip/classIp", merge(config, { params }));
}

export function postIp(params, config) {
  return http.get("/api/ip/postIp", merge(config, { params }));
}

export function ipdataPage(params, config) {
  return http.get("/api/ip/ipdataPage", merge(config, { params }));
}

export function ipcommpage(params, config) {
  return http.get("/api/ip/commpage", merge(config, { params }));
}

export function ipallcommpage(params, config) {
  return http.get("/api/ip/allcommpage", merge(config, { params }));
}

export function addIpclass(params, config) {
  return http.post(
    "/api/ip/addclass",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function addIppost(params, config) {
  return http.post(
    "/api/ip/addpost",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function bqbpage(params, config) {
  return http.get("/api/bqb/page", merge(config, { params }));
}

export function bqbmember(params, config) {
  return http.get("/api/bqb/memberlist", merge(config, { params }));
}

export function bqbcomment(params, config) {
  return http.get("/api/bqb/bqbcomment", merge(config, { params }));
}

export function bqbcat(params, config) {
  return http.get("/api/bqb/catpage", merge(config, { params }));
}

export function addbqb(params, config) {
  return http.post(
    "/api/bqb/add",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function addbqbcomment(params, config) {
  return http.post(
    "/api/bqb/addcomment",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function bqbtitle(params, config) {
  return http.post(
    "/api/bqb/bqbtitle",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function bqbactedit(params, config) {
  return http.post(
    "/api/bqb/bqbactedit",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function bqbedit(params, config) {
  return http.post(
    "/api/bqb/edit",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function bqbstance(params, config) {
  return http.post(
    "/api/bqb/mystance",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function kxccbqbstance(params, config) {
  return http.post(
    "/api/kxccbqb/mystance",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function bqbaddtwo(params, config) {
  return http.post(
    "/api/bqb/bqbaddtwo",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function bqbdownloads(params, config) {
  return http.post(
    "/api/bqb/downloads",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function bqbediturl(params, config) {
  return http.post(
    "/api/bqb/editurl",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function bqbAiProcess(params, config) {
  return http.post(
    "/api/bqb/ai_process",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function classcontent(params, config) {
  return http.get("/api/content/classcontent", merge(config, { params }));
}
export function addcontentclass(params, config) {
  return http.post(
    "/api/content/addclass",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function delcontentclass(params, config) {
  return http.post(
    "/api/content/delclass",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function editcontentclass(params, config) {
  return http.post(
    "/api/content/editclass",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function addcontent(params, config) {
  return http.post(
    "/api/content/addcon",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function getcontent(params, config) {
  return http.get("/api/content/coninfo", merge(config, { params }));
}
export function getcontenttop(params, config) {
  return http.get("/api/content/classtop", merge(config, { params }));
}
export function gettask(params, config) {
  return http.get("/api/task/lists", merge(config, { params }));
}
export function getcourselist(params, config) {
  return http.get("/api/help/courselist", merge(config, { params }));
}
export function delcourse(params, config) {
  return http.get("/api/help/delcourse", merge(config, { params }));
}
export function editcourse(params, config) {
  return http.post(
    "/api/help/editcourse",
    params,
    merge(config, { emulateJSON: false })
  );
}


export function project_design(params, config) {
  return http.get("/api/project/project", merge(config, { params }));
}

export function project_member_design(params, config) {
  return http.get("/api/project/project_member", merge(config, { params }));
}

export function project_add_design(params, config) {
  return http.get("/api/project/project_add", merge(config, { params }));
}

export function project_info_design(params, config) {
  return http.get("/api/project/project_info", merge(config, { params }));
}

export function add_item_design(params, config) {
  return http.post(
    "/api/project/add_item",
    params,
    merge(config, { emulateJSON: false })
  );
}


export function del_item_design(params, config) {
  return http.get("/api/project/del_item", merge(config, { params }));
}
export function info_item_design(params, config) {
  return http.get("/api/project/info_item", merge(config, { params }));
}
export function edit_item_design(params, config) {
  return http.post(
    "/api/project/edit_item",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function info_add_design(params, config) {
  return http.get("/api/project/info_add", merge(config, { params }));
}

export function is_open_design(params, config) {
  return http.get("/api/project/is_open", merge(config, { params }));
}

export function edit_design(params, config) {
  return http.post(
    "/api/design/edit",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function get_design(params, config) {
  return http.get("/api/design/page", merge(config, { params }));
}

export function design_status_edit(params, config) {
  return http.get("/api/design/status_edit", merge(config, { params }));
}

export function get_design_title(params, config) {
  return http.get("/api/design/liststit", merge(config, { params }));
}
export function design_type(params, config) {
  return http.get("/api/design/type_list", merge(config, { params }));
}
export function add_design_type(params, config) {
  return http.post(
    "/api/design/add_type",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function getbqbdata(params, config) {
  return http.get("/api/bqb/datas", merge(config, { params }));
}
export function getbqbsuggest(params, config) {
  return http.get("/api/bqb/suggest", merge(config, { params }));
}
export function setbqberchuang(params, config) {
  return http.get("/api/bqb/erchuangeidt", merge(config, { params }));
}


export function dialogueedit(params, config) {
  return http.post(
    "/api/bqb/dialogueedit",
    params,
    merge(config, { emulateJSON: false })
  );
}


export function senseadd(params, config) {
  return http.post(
    "/api/content/senseadd",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function senseinfo(params, config) {
  return http.get("/api/content/senseinfo", merge(config, { params }));
}
export function getbqblxlist(params, config) {
  return http.get("/api/bqb/lxlist", merge(config, { params }));
}

export function getxfxorder(params, config) {
  return http.get("/api/goods/xfx_order", merge(config, { params }));
}

export function getbqbdatalist(params, config) {
  return http.get("/api/bqbdata/lists", merge(config, { params }));
}

export function getbqbdonwdet(params, config) {
  return http.get("/api/bqbdata/destil", merge(config, { params }));
}

export function getlaxlist(params, config) {
  return http.get("/api/bqbdata/laxlist", merge(config, { params }));
}

export function getlaxdestil(params, config) {
  return http.get("/api/bqbdata/laxdestil", merge(config, { params }));
}


export function getorderlist(params, config) {
  return http.get("/api/bqbdata/orderlist", merge(config, { params }));
}
export function getgoodsorder(params, config) {
  return http.get("/api/bqbdata/goodsorder", merge(config, { params }));
}

export function getsearchlist(params, config) {
  return http.get("/api/bqbdata/searchlist", merge(config, { params }));
}
export function getsearchdestil(params, config) {
  return http.get("/api/bqbdata/searchdetil", merge(config, { params }));
}



export function getsignlist(params, config) {
  return http.get("/api/bqbdata/sign", merge(config, { params }));
}
export function getsingdestil(params, config) {
  return http.get("/api/bqbdata/signdetil", merge(config, { params }));
}

export function getbqbdelivery(params, config) {
  return http.get("/api/bqbdata/bqbdelivery", merge(config, { params }));
}
export function getbqbiswork(params, config) {
  return http.get("/api/bqb/iswork", merge(config, { params }));
}


export function getgpttext(params, config) {
  return http.get("/api/goods/gpt_text", merge(config, { params }));
}


export function getsourcepage(params, config) {
  return http.get("/api/bqbsource/page", merge(config, { params }));
}

export function sourceadd(params, config) {
  return http.post(
    "/api/bqbsource/add",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function sourceedit(params, config) {
  return http.post(
    "/api/bqbsource/edit",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function sourcedel(params, config) {
  return http.post(
    "/api/bqbsource/del",
    params,
    merge(config, { emulateJSON: false })
  );
}


export function getKxccbqbpage(params, config) {
  return http.get("/api/kxccbqb/page", merge(config, { params }));
}


export function setKxcctitle(params, config) {
  return http.post(
    "/api/kxccbqb/bqbtitle",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function delCategory(params, config) {
  return http.post(
    "/api/kxccbqb/delCategory",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function addCategory(params, config) {
  return http.post(
    "/api/kxccbqb/addCategory",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function editCategory(params, config) {
  return http.post(
    "/api/kxccbqb/editCategory",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function getkxccbqbsuggest(params, config) {
  return http.get("/api/kxccbqb/bqbsuggest", merge(config, { params }));
}


export function kxccaddbqb(params, config) {
  return http.post(
    "/api/kxccbqb/add",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function kxccbqbdel(params, config) {
  return http.post(
    "/api/kxccbqb/del",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function kxccbqbediturl(params, config) {
  return http.post(
    "/api/kxccbqb/editurl",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function getbqbdetails(params, config) {
  return http.get("/api/Bqbsource/details", merge(config, { params }));
}

export function getpointerreply(params, config) {
  return http.get("/api/Pointerreply/page", merge(config, { params }));
}

export function delpointer(params, config) {
  return http.post(
    "/api/Pointerreply/delpointer",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function getreplylist(params, config) {
  return http.get("/api/Pointerreply/replylist", merge(config, { params }));
}
export function addreply(params, config) { 
  return http.post(
  "/api/Pointerreply/addreply",
  params,
  merge(config, { emulateJSON: false })
);
}

export function getcanteenlist(params, config) {
  return http.get("/api/cookbook/page", merge(config, { params }));
}

export function kxccEditTitle(params, config) { 
  return http.post(
  "/api/kxccbqb/edittitle",
  params,
  merge(config, { emulateJSON: false })
);
}

export function getcanteenpage(params, config) {
  return http.get("/api/cookbook/lists", merge(config, { params }));
}

export function canteenEdit(params, config) { 
  return http.post(
  "/api/cookbook/edit",
  params,
  merge(config, { emulateJSON: false })
);
}

export function getWeekMenu(params, config) {
  return http.get("/api/cookbook/week_menu", merge(config, { params }));
}

export function addWeekMenu(params, config) { 
  return http.post(
  "/api/cookbook/addOrder",
  params,
  merge(config, { emulateJSON: false })
);
}

export function getCookbookPointer(params, config) {
  return http.get("/api/cookbook/pointerlist", merge(config, { params }));
}
export function getCookbookReply(params, config) {
  return http.get("/api/cookbook/replylist", merge(config, { params }));
}
export function addCookbookPointer(params, config) { 
  return http.post(
  "/api/cookbook/addreply",
  params,
  merge(config, { emulateJSON: false })
);
}
export function delCookbookPointer(params, config) { 
  return http.post(
  "/api/cookbook/delpointer",
  params,
  merge(config, { emulateJSON: false })
);
}

// export function gen_script(params, config) {
//   return http1.post(
//     "/gen_script",
//     params,
//     merge(config, { emulateJSON: false })
//   );
// }

export function getAiScript(params, config) { 
  return http.post(
  "/api/lucas/get_script",
  params,
  merge(config, { emulateJSON: false })
);
}

export function get_script_list(params, config) {
  return http.get("/api/lucas/get_script_list", merge(config, { params }));
}

export function del_ai_script(params, config) {
  return http.get("/api/lucas/del_script", merge(config, { params }));
}

export function edit_ai_script(params, config) { 
  return http.post(
  "/api/lucas/edit_script",
  params,
  merge(config, { emulateJSON: false })
);
}




export function chatimg(params, config) { 
  return http.post(
  "/api/upload/chatimg",
  params,
  merge(config, { emulateJSON: false })
);
}


export function editBqbTitle(params, config) { 
  return http.post(
  "/api/bqb/edittitle",
  params,
  merge(config, { emulateJSON: false })
);
}

export function editKxccCover(params, config) { 
  return http.post(
  "/api/kxccbqb/coverEdit",
  params,
  merge(config, { emulateJSON: false })
);
}
export function editXfxCover(params, config) { 
  return http.post(
  "/api/bqb/coverEdit",
  params,
  merge(config, { emulateJSON: false })
);
}

export function getBitableClasslists(params, config) {
  return http.get("/api/bitable/get_class", merge(config, { params }));
}
export function addBitableClass(params, config) { 
  return http.post(
  "/api/bitable/add_class",
  params,
  merge(config, { emulateJSON: false })
);
}




// WEBPACK FOOTER //
// ./src/api/api.js